import { FunctionComponent as F, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Link, TableBody, TableRow, TableCell } from "@mui/material";
import { ADD_REF } from "../../core/router/paths";
import RefsTableRowContent from "./RefsTableRowContent";
import { IValue } from "./RefsTable";
import RefsTableRowHeader from "./RefsTableRowHeader";



interface IProps
{
  topicId: number;
  headings: { Header: string; accessor: string; }[];
  records: IValue[];
  handleVote: (refId: number) => void;
}


const RefsTableBody: F<IProps> = (props: IProps) =>
{
  const navigate = useNavigate();

  const determineOpen = (records: IValue[]) =>
    Object.fromEntries(records.map(r => [r.refs[0].refId, false]));

  const [open, setOpen] = useState<{ [refdId: number]: boolean }>(determineOpen(props.records));

  useEffect(() =>
  {
    setOpen(determineOpen(props.records));
  }, [props.records.length]);

  const toggleOpen = (refId: number) =>
  {
    const newOpen = { ...open };
    newOpen[refId] = !newOpen[refId];
    setOpen(newOpen);
  };

  return (
    <>
      {props.records.map((row, rowIndex) =>
      {
        return (
          <TableBody key={rowIndex}>
            <RefsTableRowHeader
              headings={props.headings}
              row={row}
              open={open[row.refs[0].refId]}
              handleToggleOpen={toggleOpen}
              handleVote={props.handleVote}/>
            {open[row.refs[0].refId] ?
              <RefsTableRowContent
                title={row.title}
                rowLength={props.headings.length + 1}
                record={row}/> :
              <></>}
          </TableBody>);
      })}
      <TableBody>
        <TableRow>
          <TableCell colSpan={props.headings.length + 1} style={{ height: '20px', cursor: 'pointer' }}>
            <Link
              variant='body2'
              underline='hover'
              onClick={() => navigate(ADD_REF)} >
              <i>Add a reference</i>
            </Link>
          </TableCell>
        </TableRow>
      </TableBody>
    </>);
};

export default RefsTableBody;
